import { useEffect, useRef } from 'react';

export function useIdleCarouselAutoAdvance(onAdvance: () => void, idleTimeMs, advanceIntervalMs) {
    const idleTimeout = useRef<NodeJS.Timeout | null>(null);
    const intervalRef = useRef<NodeJS.Timeout | null>(null);

    useEffect(() => {
        const clearAll = () => {
            if (idleTimeout.current) clearTimeout(idleTimeout.current);
            if (intervalRef.current) clearInterval(intervalRef.current);
        };

        const handleUserActivity = () => {
            clearAll();

            idleTimeout.current = setTimeout(() => {
                onAdvance();
                intervalRef.current = setInterval(onAdvance, advanceIntervalMs);
            }, idleTimeMs);
        };

        const events = ['mousemove', 'mousedown', 'keypress', 'touchstart', 'scroll'];

        events.forEach((event) => window.addEventListener(event, handleUserActivity));

        handleUserActivity();

        return () => {
            clearAll();
            events.forEach((event) => window.removeEventListener(event, handleUserActivity));
        };
    }, [onAdvance, idleTimeMs, advanceIntervalMs]);
}
